import { Theme } from '@mui/material/styles';

// Component styles
export const styles = {
  pageContainer: { padding: 3 },
  backButton: { 
    height: 'fit-content',
    alignSelf: 'flex-start'
  },
  header: { 
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginBottom: 2,
  },
  productLine: { textAlign: 'center', marginTop: 0.5, marginBottom: 0.5 },
  headerContainer: {
    display: 'flex',
    width: '100%',
    marginBottom: 4,
  },
  headerContent: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  filtersContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 3,
    marginTop: 2,
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '200px',
  },
  paginationContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 2
  },
  sourceChip: {
    height: 24,
    fontSize: '0.75rem',
    cursor: 'pointer',
    width: 80
  },
  filterContainer: { 
    marginBottom: 3,
    padding: 2,
    backgroundColor: '#f9f9f9',
    borderRadius: 1,
    border: '1px solid #e0e0e0',
  },
  filterForm: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    flexWrap: 'wrap',
  },
  filterLabel: {
    fontWeight: 500,
    marginBottom: 1,
  },
  filterControls: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
  warningBadge: {
    marginLeft: 2,
    padding: '8px 12px',
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    borderRadius: '4px',
  },
  tableContainer: {
    width: '100%',
    overflowX: 'auto',
    '& .MuiTableCell-root': {
      boxSizing: 'border-box',
    }
  },
  stickyTable: {
    minWidth: 650,
    tableLayout: 'fixed',
    '& .MuiTableCell-root': {
      boxSizing: 'border-box',
    },
    '& .MuiTableHead-root': {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      backgroundColor: '#fff'
    },
    '& .MuiTableCell-head': {
      height: 56, // DataGrid default header height
      padding: '0 16px'
    },
    '& .MuiTableCell-body': {
      height: 52, // DataGrid default row height
      padding: '0 16px'
    }
  },
  tableCell: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '&.MuiTableCell-sizeMedium': {
      padding: '6px 10px'
    }
  },
  tableCellHeader: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    '&.MuiTableCell-head': {
      fontWeight: 'bold'
    },
    '&.MuiTableCell-sizeMedium': {
      padding: '8px 12px'
    }
  },
  columnMenuButton: {
    padding: 0,
    marginLeft: 1,
    color: 'rgba(0, 0, 0, 0.54)'
  },
  columnManagerDialog: {
    minWidth: 300
  },
  columnHeaderContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  },
  headerLabelContainer: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    flexGrow: 1
  }
};

/**
 * Get dynamic styles based on theme
 */
export const getDynamicStyles = (theme: Theme) => ({
  sourceChipSuccess: {
    ...styles.sourceChip,
    bgcolor: theme.palette.success.dark
  },
  typographyHot: {
    color: theme.palette.error.dark
  },
  typographyPrimary: {
    color: theme.palette.primary.main
  }
});

/**
 * Table cell styling helper
 */
export const getTableCellStyles = (isHeader: boolean = false) => {
  return isHeader ? styles.tableCellHeader : styles.tableCell;
}; 